const messages = {
    en: {
        message: {
            home: "Home",
            feed: 'Feed',
            events: "Events",
            livestream: "Livestrem",
            search: 'Search',
            invite: 'Invite',
            groups: 'Groups',
            courses: "Courses",
            songs: "Songs",
            giving: "Giving",
            profile: "Profile",
            settings: 'Settings',
            logout: "Logout",
            statusUpdate: "New Post",
            newsPost: "News Post",
            post: "Post",
            add: 'Add',
            whatIsNew: "What is new?",
            saySomethingTo: "Say something to ",
            follow: "Follow",
            unfollow: "Unfollow",
            subscribe: "Subscribe",
            unsubscribe: 'Unsubscribe',
            pending: "Pending",
            subscribers: "Subscribers",
            loading: "Loading",
            login: 'Login',
            email: "Email",
            password: "Password",
            rpassword: "Repeat Password",
            register: "Register",
            name: "Name",
            lastName: "Last Name",
            describeYourself: 'Describe Yourself',
            continueWatching: "Continues Watching",
            createCourse: "Create a your own new course!",
            createGroup: "Create a your own new group!",
            title: "Title",
            subtitle: "Subtitle",
            recentlyAdded: "Recently added",
            popularCourses: "Popular Courses",
            privateGroup: "Private Group",
            tithesAndOfferings: "Tithes and Offerings",
            type: "Type",
            description: "Description",
            amount: "Amount",
            tithes: "Tithes",
            offerings: "Offerings",
            event: "Event",
            proceedToPayment: "Proceed to Payment",
            minimumAmount: "The minimum amount is ",
            notifications: "Notifications",
            globalChat: "Global Chat",
            onlineNow: "Online now",
            loadingChat: "Loading chat...",
            writeMessage: "Write a message...",
            aiTranslated: "AI translated",
            bible: "Bible",
            unableLoadPassage: "Unable to load Bible passage.",
            unableLoadChapter: "Unable to load Bible chapter.",
            noUsersOnline: "No users online",
            send: "Send",
            liveCaptions: "Live Captions",
            liveCaptionsSubtitle: "Realtime captions for current service",
            liveNow: "Live",
            translationLanguage: "Translation language",
            selectedTranslation: "Selected translation",
            originalLanguage: "Original",
            loadingLiveCaptions: "Loading live captions...",
            awaitingLiveCaptions: "Waiting for live captions...",
            translationFallback: "Translation unavailable for this line. Showing original text.",
            languageEnglish: "English",
            languageSpanish: "Spanish",
            languageFrench: "French",
            languageDanish: "Danish",
            languageArabic: "Arabic",
            biblePickerSubtitlePost: "Select a book and chapter to start reading.",
            book: "Book",
            chapter: "Chapter",
            books: "Books",
            chapters: "Chapters",
            verses: "Verses",
            readFullChapter: "Read Full Chapter",
            seeOriginal: "See Original",
            seeTranslation: "See Translation",
            translating: "Translating...",
            previous: "Previous",
            next: "Next",
            checkInvitation: "Check Invitation",
            checking: "Checking...",
            invitationFound: "Great! Please complete your profile.",
            checkInvitationSubtitle: "Let's check if you have an invitation.",
            noInvitationFound: "No invitation found for this email.",
            errorCheckingInvitation: "An error occurred while checking the invitation.",
            useDifferentEmail: "Use a different email",
            welcomeBack: "Welcome back! Please enter your details.",
            rememberMe: "Remember me",
            forgotPassword: "Forgot password?",
            signInWith: "Or sign in with",
            oneTimeLink: "One-time sign-in link",
            fillAllFields: "Please fill in all fields",
            enterEmailFirst: "Please enter your email first",
            joinCommunity: "Join our community! Please fill in your details.",
        },
    },
    es: {
        message: {
            home: "Inicio",
            feed: 'Mural',
            events: "Eventos",
            livestream: "En Vivo",
            search: 'Busqueda',
            invite: "Invitaciones",
            groups: 'Grupos',
            courses: 'Cursos',
            songs: "Canciones",
            giving: "Ofrendas",
            profile: "Perfil",
            settings: 'Configuraciones',
            logout: "Cerrar Sesión",
            statusUpdate: "Publicación Nueva",
            newsPost: "Noticias?",
            post: "Publica",
            add: 'Añade',
            whatIsNew: "Que hay de nuevo?",
            saySomethingTo: "Publica algo para ",
            follow: "Seguir",
            unfollow: "No Seguir",
            subscribe: "Afiliar",
            unsubscribe: 'Abandonar',
            pending: "Pendiente",
            subscribers: "Subscriptores",
            loading: "Cargando",
            login: 'Inicia Sesión',
            email: "Correo Electronico",
            password: "Contraseña",
            rpassword: "Confirma tu Contraseña",
            register: "Registrate",
            name: 'Nombre',
            lastName: "Apellido",
            describeYourself: 'Describete en unas cuantas palabras',
            continueWatching: "Continua viendo",
            createCourse: "Crea tu propio curso!",
            createGroup: "Crea un grupo nuevo!",
            title: "Titulo",
            subtitle: "Subtitulo",
            recentlyAdded: "Recientemente añadido",
            popularCourses: "Cursos populares",
            privateGroup: "Grupo privado",
            tithesAndOfferings: "Diezmos y Ofrendas",
            type: "Tipo",
            description: "Descripción",
            amount: "Cantidad",
            tithes: "Diezmos",
            offerings: "Ofrendas",
            event: "Evento",
            proceedToPayment: "Continuar con el pago",
            minimumAmount: "La cantidad mínima es de ",
            notifications: "Notificaciones",
            globalChat: "Chat Global",
            onlineNow: "En línea",
            loadingChat: "Cargando chat...",
            writeMessage: "Escribe un mensaje...",
            aiTranslated: "Traducido por IA",
            bible: "Biblia",
            unableLoadPassage: "No se pudo cargar el pasaje bíblico.",
            unableLoadChapter: "No se pudo cargar el capítulo bíblico.",
            noUsersOnline: "No hay usuarios en línea",
            send: "Enviar",
            liveCaptions: "Subtítulos en vivo",
            liveCaptionsSubtitle: "Subtítulos en tiempo real del servicio actual",
            liveNow: "En vivo",
            translationLanguage: "Idioma de traducción",
            selectedTranslation: "Traducción seleccionada",
            originalLanguage: "Original",
            loadingLiveCaptions: "Cargando subtítulos en vivo...",
            awaitingLiveCaptions: "Esperando subtítulos en vivo...",
            translationFallback: "No hay traducción para esta línea. Mostrando texto original.",
            languageEnglish: "Inglés",
            languageSpanish: "Español",
            languageFrench: "Francés",
            languageDanish: "Danés",
            languageArabic: "Árabe",
            biblePickerSubtitlePost: "Seleccione un libro y un capítulo para comenzar a leer.",
            book: "Libro",
            chapter: "Capítulo",
            books: "Libros",
            chapters: "Capítulos",
            verses: "Versículos",
            readFullChapter: "Leer capítulo completo",
            seeOriginal: "Ver original",
            seeTranslation: "Ver traducción",
            translating: "Traduciendo...",
            previous: "Anterior",
            next: "Siguiente",
            checkInvitation: "Comprobar Invitación",
            checking: "Comprobando...",
            invitationFound: "¡Genial! Por favor completa tu perfil.",
            checkInvitationSubtitle: "Vamos a comprobar si tienes una invitación.",
            noInvitationFound: "No se encontró ninguna invitación para este correo.",
            errorCheckingInvitation: "Ocurrió un error al comprobar la invitación.",
            useDifferentEmail: "Usar un correo diferente",
            welcomeBack: "¡Bienvenido de nuevo! Por favor ingresa tus datos.",
            rememberMe: "Recordarme",
            forgotPassword: "¿Olvidaste tu contraseña?",
            signInWith: "O inicia sesión con",
            oneTimeLink: "Enlace de acceso único",
            fillAllFields: "Por favor completa todos los campos",
            enterEmailFirst: "Por favor ingresa tu correo primero",
            joinCommunity: "¡Únete a nuestra comunidad! Por favor completa tus datos.",
        },
    },
    fr: {
        message: {
            home: "Accueil",
            feed: "Fil d'actualité",
            events: "Événements",
            livestream: "Diffusion en direct",
            search: "Rechercher",
            invite: "Inviter",
            groups: "Groupes",
            courses: "Cours",
            songs: "Chansons",
            giving: "Don",
            profile: "Profil",
            settings: "Paramètres",
            logout: "Se déconnecter",
            statusUpdate: "Nouvelle publication",
            newsPost: "Publication de nouvelles",
            post: "Publier",
            add: "Ajouter",
            whatIsNew: "Quoi de neuf ?",
            saySomethingTo: "Dire quelque chose à ",
            follow: "Suivre",
            unfollow: "Ne plus suivre",
            subscribe: "S'abonner",
            unsubscribe: "Se désabonner",
            pending: "En attente",
            subscribers: "Abonnés",
            loading: "Chargement",
            login: "Connexion",
            email: "E-mail",
            password: "Mot de passe",
            rpassword: "Répéter le mot de passe",
            register: "S'inscrire",
            name: "Nom",
            lastName: "Nom de famille",
            describeYourself: "Décrivez-vous",
            continueWatching: "Continuer à regarder",
            createCourse: "Créez votre propre cours !",
            createGroup: "Créez votre propre groupe !",
            title: "Titre",
            subtitle: "Sous-titre",
            recentlyAdded: "Ajouté récemment",
            popularCourses: "Cours populaires",
            privateGroup: "Groupe privé",
            tithesAndOfferings: "Dîmes et Offrandes",
            type: "Type",
            description: "Description",
            amount: "Montant",
            tithes: "Dîmes",
            offerings: "Offrandes",
            event: "Événement",
            proceedToPayment: "Procéder au paiement",
            minimumAmount: "Le montant minimum est ",
            notifications: "Notifications",
            globalChat: "Chat global",
            onlineNow: "En ligne",
            loadingChat: "Chargement du chat...",
            writeMessage: "Écrire un message...",
            aiTranslated: "Traduit par IA",
            bible: "Bible",
            unableLoadPassage: "Impossible de charger le passage biblique.",
            unableLoadChapter: "Impossible de charger le chapitre biblique.",
            noUsersOnline: "Aucun utilisateur en ligne",
            send: "Envoyer",
            liveCaptions: "Sous-titres en direct",
            liveCaptionsSubtitle: "Sous-titres en temps réel du service en cours",
            liveNow: "En direct",
            translationLanguage: "Langue de traduction",
            selectedTranslation: "Traduction sélectionnée",
            originalLanguage: "Original",
            loadingLiveCaptions: "Chargement des sous-titres en direct...",
            awaitingLiveCaptions: "En attente des sous-titres en direct...",
            translationFallback: "Traduction indisponible pour cette ligne. Texte original affiché.",
            languageEnglish: "Anglais",
            languageSpanish: "Espagnol",
            languageFrench: "Français",
            languageDanish: "Danois",
            languageArabic: "Arabe",
            biblePickerSubtitlePost: "Sélectionnez un livre et un chapitre pour commencer à lire.",
            book: "Livre",
            chapter: "Chapitre",
            books: "Livres",
            chapters: "Chapitres",
            verses: "Versets",
            readFullChapter: "Lire le chapitre complet",
            seeOriginal: "Voir l'original",
            seeTranslation: "Voir la traduction",
            translating: "Traduction en cours...",
            previous: "Précédent",
            next: "Suivant",
            checkInvitation: "Vérifier l'invitation",
            checking: "Vérification...",
            invitationFound: "Super ! Veuillez compléter votre profil.",
            checkInvitationSubtitle: "Vérifions si vous avez une invitation.",
            noInvitationFound: "Aucune invitation trouvée pour cet e-mail.",
            errorCheckingInvitation: "Une erreur est survenue lors de la vérification de l'invitation.",
            useDifferentEmail: "Utiliser un e-mail différent",
            welcomeBack: "Bon retour ! Veuillez saisir vos coordonnées.",
            rememberMe: "Se souvenir de moi",
            forgotPassword: "Mot de passe oublié ?",
            signInWith: "Ou connectez-vous avec",
            oneTimeLink: "Lien de connexion unique",
            fillAllFields: "Veuillez remplir tous les champs",
            enterEmailFirst: "Veuillez d'abord saisir votre e-mail",
            joinCommunity: "Rejoignez notre communauté ! Veuillez remplir vos coordonnées.",
        },
    },
    da: {
        message: {
            home: "Hjem",
            feed: "Feed",
            events: "Begivenheder",
            livestream: "Live stream",
            search: "Søg",
            invite: "Inviter",
            groups: "Grupper",
            courses: "Kurser",
            songs: "Sange",
            giving: "Donation",
            profile: "Profil",
            settings: "Indstillinger",
            logout: "Log ud",
            statusUpdate: "Nyt opslag",
            newsPost: "Nyhedsopslag",
            post: "Opslag",
            add: "Tilføj",
            whatIsNew: "Hvad er nyt?",
            saySomethingTo: "Skriv noget til ",
            follow: "Følg",
            unfollow: "Følg ikke",
            subscribe: "Abonner",
            unsubscribe: "Afmeld",
            pending: "Afventer",
            subscribers: "Abonnenter",
            loading: "Indlæser",
            login: "Log ind",
            email: "E-mail",
            password: "Adgangskode",
            rpassword: "Gentag adgangskode",
            register: "Registrer",
            name: "Navn",
            lastName: "Efternavn",
            describeYourself: "Beskriv dig selv",
            continueWatching: "Fortsæt med at se",
            createCourse: "Opret dit eget kursus!",
            createGroup: "Opret din egen gruppe!",
            title: "Titel",
            subtitle: "Undertitel",
            recentlyAdded: "Senest tilføjet",
            popularCourses: "Populære kurser",
            privateGroup: "Privat gruppe",
            tithesAndOfferings: "Tiende og gaver",
            type: "Type",
            description: "Beskrivelse",
            amount: "Beløb",
            tithes: "Tiende",
            offerings: "Gaver",
            event: "Begivenhed",
            proceedToPayment: "Fortsæt til betaling",
            minimumAmount: "Minimumsbeløbet er ",
            notifications: "Notifikationer",
            globalChat: "Global chat",
            onlineNow: "Online nu",
            loadingChat: "Indlæser chat...",
            writeMessage: "Skriv en besked...",
            aiTranslated: "AI-oversat",
            bible: "Bibel",
            unableLoadPassage: "Kunne ikke indlæse bibelpassage.",
            unableLoadChapter: "Kunne ikke indlæse bibelkapitel.",
            noUsersOnline: "Ingen brugere online",
            send: "Send",
            liveCaptions: "Live undertekster",
            liveCaptionsSubtitle: "Realtidsundertekster for nuværende gudstjeneste",
            liveNow: "Live",
            translationLanguage: "Oversættelsessprog",
            selectedTranslation: "Valgt oversættelse",
            originalLanguage: "Original",
            loadingLiveCaptions: "Indlæser live undertekster...",
            awaitingLiveCaptions: "Venter på live undertekster...",
            translationFallback: "Oversættelse er ikke tilgængelig for denne linje. Viser original tekst.",
            languageEnglish: "Engelsk",
            languageSpanish: "Spansk",
            languageFrench: "Fransk",
            languageDanish: "Dansk",
            languageArabic: "Arabisk",
            biblePickerSubtitlePost: "Vælg en bog og et kapitel for at begynde at læse.",
            book: "Bog",
            chapter: "Kapitel",
            books: "Bøger",
            chapters: "Kapitler",
            verses: "Vers",
            readFullChapter: "Læs hele kapitlet",
            seeOriginal: "Se original",
            seeTranslation: "Se oversættelse",
            translating: "Oversætter...",
            previous: "Forrige",
            next: "Næste",
            checkInvitation: "Tjek invitation",
            checking: "Tjekker...",
            invitationFound: "Fantastisk! Udfyld venligst din profil.",
            checkInvitationSubtitle: "Lad os tjekke, om du har en invitation.",
            noInvitationFound: "Ingen invitation fundet for denne e-mail.",
            errorCheckingInvitation: "Der opstod en fejl under tjek af invitationen.",
            useDifferentEmail: "Brug en anden e-mail",
            welcomeBack: "Velkommen tilbage! Indtast venligst dine oplysninger.",
            rememberMe: "Husk mig",
            forgotPassword: "Glemt adgangskode?",
            signInWith: "Eller log ind med",
            oneTimeLink: "Engangslogon-link",
            fillAllFields: "Udfyld venligst alle felter",
            enterEmailFirst: "Indtast venligst din e-mail først",
            joinCommunity: "Bliv en del af vores fællesskab! Udfyld venligst dine oplysninger.",
        },
    },
    ar: {
        message: {
            home: "الرئيسية",
            feed: "المنشورات",
            events: "الفعاليات",
            livestream: "البث المباشر",
            search: "بحث",
            invite: "دعوة",
            groups: "المجموعات",
            courses: "الدورات",
            songs: "الترانيم",
            giving: "العطاء",
            profile: "الملف الشخصي",
            settings: "الإعدادات",
            logout: "تسجيل الخروج",
            statusUpdate: "منشور جديد",
            newsPost: "منشور إخباري",
            post: "نشر",
            add: "إضافة",
            whatIsNew: "ما الجديد؟",
            saySomethingTo: "قل شيئًا إلى ",
            follow: "متابعة",
            unfollow: "إلغاء المتابعة",
            subscribe: "اشتراك",
            unsubscribe: "إلغاء الاشتراك",
            pending: "قيد الانتظار",
            subscribers: "المشتركون",
            loading: "جارٍ التحميل",
            login: "تسجيل الدخول",
            email: "البريد الإلكتروني",
            password: "كلمة المرور",
            rpassword: "تأكيد كلمة المرور",
            register: "إنشاء حساب",
            name: "الاسم",
            lastName: "اسم العائلة",
            describeYourself: "عرّف بنفسك",
            continueWatching: "متابعة المشاهدة",
            createCourse: "أنشئ دورتك الجديدة الخاصة!",
            createGroup: "أنشئ مجموعتك الجديدة الخاصة!",
            title: "العنوان",
            subtitle: "العنوان الفرعي",
            recentlyAdded: "أضيف مؤخرًا",
            popularCourses: "الدورات الشائعة",
            privateGroup: "مجموعة خاصة",
            tithesAndOfferings: "العشور والتقدمات",
            type: "النوع",
            description: "الوصف",
            amount: "المبلغ",
            tithes: "العشور",
            offerings: "التقدمات",
            event: "فعالية",
            proceedToPayment: "المتابعة إلى الدفع",
            minimumAmount: "الحد الأدنى للمبلغ هو ",
            notifications: "الإشعارات",
            globalChat: "الدردشة العامة",
            onlineNow: "متصل الآن",
            loadingChat: "جارٍ تحميل الدردشة...",
            writeMessage: "اكتب رسالة...",
            aiTranslated: "مترجم بالذكاء الاصطناعي",
            bible: "الكتاب المقدس",
            unableLoadPassage: "تعذر تحميل المقطع الكتابي.",
            unableLoadChapter: "تعذر تحميل الإصحاح.",
            noUsersOnline: "لا يوجد مستخدمون متصلون",
            send: "إرسال",
            liveCaptions: "ترجمة حية",
            liveCaptionsSubtitle: "ترجمة فورية للخدمة الحالية",
            liveNow: "مباشر",
            translationLanguage: "لغة الترجمة",
            selectedTranslation: "الترجمة المختارة",
            originalLanguage: "الأصلية",
            loadingLiveCaptions: "جارٍ تحميل الترجمة الحية...",
            awaitingLiveCaptions: "بانتظار الترجمة الحية...",
            translationFallback: "الترجمة غير متاحة لهذا السطر. يتم عرض النص الأصلي.",
            languageEnglish: "الإنجليزية",
            languageSpanish: "الإسبانية",
            languageFrench: "الفرنسية",
            languageDanish: "الدنماركية",
            languageArabic: "العربية",
            biblePickerSubtitlePost: "اختر سفرًا وإصحاحًا لبدء القراءة.",
            book: "السفر",
            chapter: "الإصحاح",
            books: "الأسفار",
            chapters: "الإصحاحات",
            verses: "الآيات",
            readFullChapter: "قراءة الإصحاح كاملًا",
            seeOriginal: "عرض الأصل",
            seeTranslation: "عرض الترجمة",
            translating: "جارٍ الترجمة...",
            previous: "السابق",
            next: "التالي",
            checkInvitation: "التحقق من الدعوة",
            checking: "جارٍ التحقق...",
            invitationFound: "رائع! يرجى إكمال ملفك الشخصي.",
            checkInvitationSubtitle: "دعنا نتحقق مما إذا كانت لديك دعوة.",
            noInvitationFound: "لم يتم العثور على دعوة لهذا البريد الإلكتروني.",
            errorCheckingInvitation: "حدث خطأ أثناء التحقق من الدعوة.",
            useDifferentEmail: "استخدام بريد إلكتروني مختلف",
            welcomeBack: "مرحبًا بعودتك! يرجى إدخال بياناتك.",
            rememberMe: "تذكرني",
            forgotPassword: "هل نسيت كلمة المرور؟",
            signInWith: "أو سجّل الدخول باستخدام",
            oneTimeLink: "رابط دخول لمرة واحدة",
            fillAllFields: "يرجى تعبئة جميع الحقول",
            enterEmailFirst: "يرجى إدخال بريدك الإلكتروني أولًا",
            joinCommunity: "انضم إلى مجتمعنا! يرجى تعبئة بياناتك.",
        },
    }
}


export default messages;
